














import { Component, Vue } from 'vue-property-decorator';
import api from '@/util/api';

@Component ({})
export default class Register extends Vue
{
	file: any = null;
	ready = false;
	imagePreview = '';

	handleFileUpload ()
	{
		// @ts-ignore
		this.file = this.$refs.file.files[0];
		const reader = new FileReader();
		reader.addEventListener ("load", () =>
		{
			this.ready = true;
			this.imagePreview = reader.result;
		});
		if (this.file && /\.(jpe?g|png|gif)$/i.test (this.file.name))
			reader.readAsDataURL (this.file);
	}

	upload ()
	{
		return api.upload (this.file);
	}
}

